import { UserModel } from "model";

// import { BUILD_PROFILE } from "./build";

// To toggle off a feature only in prod, you can set the value like:
// EXPORT_REQUESTS: BUILD_PROFILE !== "prod"

export function getFeatureFlags(user?: UserModel) {
  return {
    // Default rules
    SUB_MAP_TOOL: user?.isSuperAdmin,
    WAITLIST_TOOL: user?.isSuperAdmin,
    // TODO: Once we release this feature, we can uncomment this code.
    BILLING_PAGE: user?.isSuperAdmin || user?.isBillingAdmin,
    /**
     * Feature flag for disabling School Closures when creating or duplicating
     * a Request.
     *
     * Enabled for all users.
     *
     * Linear: https://linear.app/swing-education/project/swing-schools-default-request-creationduplication-without-school-c3ab345033fa/overview
     * Remove in https://linear.app/swing-education/issue/MKTP-928
     */
    DISABLE_SCHOOL_CLOSURES: true,
    SUB_RATINGS_V3_P1: true,
    // Feature flag for new School Years V2
    // TODO: Remove after releasing https://linear.app/swing-education/project/swing-schools-school-years-v2-f718e01c116c
    SCHOOL_YEARS_V2: true,
    NON_SCHOOL_DAYS_V2: user?.isSuperAdmin,
    SUB_RATINGS_V3_P2: true,
    EXTEND_WAITLISTED_FILLED_REQUESTS: user?.isSuperAdmin,
  };
}
